import React from 'react';
import PropTypes from 'prop-types';

const Svg = ({ children, width, height, viewBox, id }) => (
   <svg
      id={id || null}
      width={width}
      height={height}
      viewBox={`0 0 ${viewBox}`}
      style={{ width, height }}
      version="1.1" xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
   >
      {children}
   </svg>
);

Svg.defaultProps = {
   width: 16,
   height: 16,
   viewBox: '16 16'
};

Svg.propTypes = {
   width: PropTypes.any,
   height: PropTypes.any
};

export default Svg;
